import React from 'react';
import { ModelListEditor, Toolbar } from '@leverege/ui-plugin';
import { Content, Pane, Dialogs } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import DeleteDialog from "../deleteDialog/DeleteDialog.js";
import Pagination from "../pagination/Pagination.js";
import RsrcModel from "../../models/Rsrc.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TYPE = 'rsrc.listRenderer.list';
const matchContext = {
  client: TYPE,
  objectType: RsrcModel.TYPE
};
class RsrcList extends React.Component {
  onSelect = evt => {
    console.log(evt);
  };
  onChange = evt => {
    console.log(evt);
  };
  getContext = () => {
    const {
      targeted
    } = this.props;
    return {
      clientProps: this.props,
      target: targeted?.items
    };
  };
  removeItem = (list, removed) => {
    const {
      reload,
      resourceApi
    } = this.props;
    Dialogs.show({
      component: DeleteDialog,
      props: {
        rsrc: [removed],
        onDelete: async value => {
          await GlobalState.dispatch(resourceApi.resource(RsrcModel.getPath(value)).delete());
          await reload();
        }
      }
    });
    return list.filter(i => i.id !== removed.id);
  };
  indexOf(list, item) {
    for (let i = 0; i < list.length; i++) {
      if (list[i].id === item.id) {
        return i;
      }
    }
    return -1;
  }
  set = (value, index, newValue) => {
    const {
      resourceApi,
      reload
    } = this.props;
    const toReturn = [...value];
    toReturn[index] = newValue;
    const oldValue = value[index];
    const ops = [];
    if (RsrcModel.getPath(oldValue) !== RsrcModel.getPath(newValue)) {
      ops.push({
        path: 'path',
        value: RsrcModel.getPath(newValue)
      });
    }
    if (RsrcModel.getRsrcType(oldValue) !== RsrcModel.getRsrcType(newValue)) {
      ops.push({
        path: 'type',
        value: RsrcModel.getRsrcType(newValue)
      });
    }
    if (RsrcModel.getData(oldValue) !== RsrcModel.getData(newValue)) {
      ops.push({
        path: 'data',
        value: RsrcModel.getData(newValue)
      });
    }
    GlobalState.dispatch(resourceApi.resource(RsrcModel.getPath(oldValue)).update(ops)).then(() => reload());
    return toReturn;
  };
  render() {
    const {
      paginator
    } = this.props;
    const context = this.getContext();
    return /*#__PURE__*/_jsxs(Content, {
      children: [/*#__PURE__*/_jsx(Content.Header, {
        children: /*#__PURE__*/_jsxs(Pane, {
          layout: "flex:rowSpaceBetween",
          children: [/*#__PURE__*/_jsx(Toolbar, {
            variant: "actionBar",
            prefer: "icon",
            hasContextMenu: true,
            contextMenuHideWhenEmpty: true,
            matchContext: {
              ...matchContext,
              use: 'actionBarLeft'
            },
            context: context
          }), /*#__PURE__*/_jsx(Toolbar, {
            variant: "actionBar",
            prefer: "icon",
            matchContext: {
              ...matchContext,
              use: 'actionBarRight'
            },
            context: context
          })]
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        children: /*#__PURE__*/_jsx(ModelListEditor, {
          model: {
            getAll: () => paginator.pageItems,
            remove: this.removeItem,
            indexOf: this.indexOf,
            set: this.set
          },
          onSelect: this.onSelect,
          rendererName: "ref"
          // selectedProps={this.props}
          ,
          onChange: this.onChange,
          value: paginator.pageItems
        })
      }), /*#__PURE__*/_jsx(Content.Footer, {
        children: /*#__PURE__*/_jsx(Pagination, {
          paginator: paginator,
          matchContext: matchContext,
          context: context
        })
      })]
    });
  }
}
RsrcList.TYPE = TYPE;
RsrcList.PLUGIN = {
  type: TYPE,
  component: RsrcList
};
export default RsrcList;